import moment, { DATE_FORMAT } from '@/utils/moment-wrapper';

export function buildGuideViewedFilterString ({ filterIndex }) {
    return `!isNull(lastState${filterIndex})`;
}

export function buildGuideNotViewedFilterString ({ filterIndex }) {
    return `isNull(lastState${filterIndex})`;
}

export function buildGuideTimeBeforeFilterString ({ filterIndex, first }) {
    const date = moment(first, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);

    return `guideFirstTime${filterIndex}<=date("${date}")`;
}

export function buildGuideTimeSinceFilterString ({ filterIndex, first }) {
    const date = moment(first, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);

    return `guideLastTime${filterIndex}>=date("${date}")`;
}

export function buildGuideTimeBetweenFilterString ({ filterIndex, first, last }) {
    const formattedFirst = moment(first, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);
    const formattedLast = moment(last, { ignoreTimeZone: true })
        .add(1, 'days')
        .format(DATE_FORMAT.iso);

    return `(guideLastTime${filterIndex}>=date("${formattedFirst}")&&guideLastTime${filterIndex}<date("${formattedLast}"))`;
}

export function buildGuideLastTimeBeforeFilterString ({ filterIndex, first }) {
    const date = moment(first, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);

    return `guideLastTime${filterIndex}<=date("${date}")`;
}

export function buildGuideTimeWithinLastFilterString ({ filterIndex, count, granularity }) {
    return `guideLastTime${filterIndex}>=dateAdd(startOfPeriod("daily",now()),-${count},"${granularity}")`;
}

export function buildGuideTimeNotWithinLastFilterString ({ filterIndex, count, granularity }) {
    return `(guideLastTime${filterIndex}>=now()||guideLastTime${filterIndex}<=dateAdd(startOfPeriod("daily",now()),-${count},"${granularity}"))`;
}

export function buildGuideSeenAtLeastOrMostFilterString ({ filterIndex, value, comparisonSymbol }) {
    return `guideSeenCount${filterIndex}${comparisonSymbol}${value}`;
}

export function parseGuideFilterPipeline ({ fact, time, ...params }) {
    let filterString;

    switch (fact) {
        case 'viewed':
            filterString = buildGuideViewedFilterString(params);
            switch (time) {
                case '<=':
                    filterString += `&&${buildGuideTimeBeforeFilterString(params)}`;
                    break;
                case '>=':
                    filterString += `&&${buildGuideTimeSinceFilterString(params)}`;
                    break;
                case 'withinLast':
                    filterString += `&&${buildGuideTimeWithinLastFilterString(params)}`;
                    break;
                case '!withinLast':
                    filterString += `&&${buildGuideTimeNotWithinLastFilterString(params)}`;
                    break;
                case 'atleast':
                    filterString += `&&${buildGuideSeenAtLeastOrMostFilterString({
                        comparisonSymbol: '>=',
                        ...params,
                    })}`;
                    break;
                case 'atmost': {
                    filterString = buildGuideNotViewedFilterString(params);
                    filterString += `||${buildGuideSeenAtLeastOrMostFilterString({
                        comparisonSymbol: '<=',
                        ...params,
                    })}`;
                    break;
                }
                // default 'ever'; nothing appended
            }
            break;
        case 'lastviewed':
            filterString = buildGuideViewedFilterString(params);
            switch (time) {
                case '<=':
                    filterString += `&&${buildGuideLastTimeBeforeFilterString(params)}`;
                    break;
                case '>=':
                    filterString += `&&${buildGuideTimeSinceFilterString(params)}`;
                    break;
                case 'withinLast':
                    filterString += `&&${buildGuideTimeWithinLastFilterString(params)}`;
                    break;
                case '!withinLast':
                    filterString += `&&${buildGuideTimeNotWithinLastFilterString(params)}`;
                    break;
                case 'between':
                    filterString += `&&${buildGuideTimeBetweenFilterString(params)}`;
                    break;
            }
            break;
        case 'notviewed':
            filterString = buildGuideNotViewedFilterString(params);
            switch (time) {
                case '<=':
                    filterString += `||!(${buildGuideTimeBeforeFilterString(params)})`;
                    break;
                case '>=':
                    filterString += `||!(${buildGuideTimeSinceFilterString(params)})`;
                    break;
                case 'withinLast':
                    filterString += `||!(${buildGuideTimeWithinLastFilterString(params)})`;
                    break;
                case '!withinLast':
                    filterString += `||!(${buildGuideTimeNotWithinLastFilterString(params)})`;
                    break;
                // default 'ever'; nothing appended
            }
            break;
    }

    return { filter: filterString };
}
